import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons/faCircleNotch';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons/faAngleRight';
import classNames from 'classnames';
import { shouldKeyTrigger } from 'phoenix2/utils/keyboard';

// Only accept 'submit' & 'button' types
type ButtonTypes = 'submit' | 'button';

interface INewUserButtonProps {
    type: ButtonTypes; // The type of button this component is being used as
    value: string; // Text on the button
    disabled?: boolean; // Add a disabled state to the button
    handleClick?: () => void; // Handle a click event on the button
    showIcon?: boolean; // Show the chevron
    showSpinner?: boolean; // Show a loading spinner
}

/**
 * Standardised button component to be used in the 'new user' flow.
 * Can be used for submit & click events.
 */
const NewUserButton = ({
    disabled,
    handleClick,
    value,
    type,
    showIcon,
    showSpinner,
}: INewUserButtonProps): JSX.Element => {
    const isSubmit = type === 'submit';
    return (
        <button
            type={type}
            className={classNames('btn', {
                'btn-disabled': disabled,
                // If the button is not a submit button it will be the secondary call
                // to action on the page so add relevant classes
                'btn-secondary': !isSubmit,
            })}
            disabled={disabled}
            onClick={() => handleClick && handleClick()}
            onKeyDown={evt => shouldKeyTrigger(evt) && handleClick && handleClick()}
        >
            {value} {isSubmit && showIcon && <FontAwesomeIcon icon={faAngleRight} />}
            {showSpinner && <FontAwesomeIcon icon={faCircleNotch} spin />}
        </button>
    );
};

export default NewUserButton;
